import {useState} from 'react';
import uniqBy from 'lodash/uniqBy';

import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ProviderChip from '../providers/ProviderChip';
import LeadSubscriberDialog from './LeadSubscriberDialog';

import {formatProviderName} from '../../helpers/providers';
import {useUpdateLeadMutation} from '../../redux/services/leadApi';
import {useGetProvidersQuery} from '../../redux/services/providerApi';

const removeHandler = ({lead, put}) => subscriber_id => async e => {
  const subscriber_ids = (lead.subscriber_ids || []).filter(id => id !== subscriber_id);
  const request = await put({id: lead.id, body: {subscriber_ids}});
};

const LeadCommentSubscribers = props => {
  const {lead} = props;
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [put] = useUpdateLeadMutation();
  const assigneeQuery = useGetProvidersQuery(
    {id: lead.provider_id},
    {skip: !lead.provider_id}
  );
  const subscribersQuery = useGetProvidersQuery(
    {ids: lead?.subscriber_ids},
    {skip: !lead?.subscriber_ids || lead?.subscriber_ids?.length === 0}
  );
  const subscribers = uniqBy([
    ...(assigneeQuery.data || []),
    ...(subscribersQuery.data || [])
  ], 'id');
  const onRemoveSubscriber = removeHandler({lead, put});
  return (
    <>
      <LeadSubscriberDialog 
        lead={lead} 
        dialogIsOpen={dialogIsOpen} 
        onClose={() => setDialogIsOpen(false)}
      />
      <Stack direction='row' flexWrap='wrap' gap={1}>
        {subscribers.map(s => (
          <Stack direction={'row'}>
            <ProviderChip 
              provider={s} 
              key={s.id} 
              onDelete={s.id === lead.provider_id ? undefined : onRemoveSubscriber(s.id)}
            />
          </Stack>
        ))}
        <IconButton
          size='small'
          color='primary'
          onClick={() => setDialogIsOpen(true)}
        >
          <AddIcon />
        </IconButton>
      </Stack>
    </>
  );
};

export default LeadCommentSubscribers;